import { VALUES } from "@/data";
import { Check } from "lucide-react";

export const About = () => {
  return (
    <section id="about" className="bg-white border-y-2 border-[#0F0F0F]/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <img
            data-testid="about-image"
            src="https://static.prod-images.emergentagent.com/jobs/016c2c00-fb23-4638-aeeb-f9017e46f4a1/images/894f1a00162e19f6341be00cfcbc345590b6f42a2668fd03d11490b1153edd55.png"
            alt="Diverse hands holding house keys"
            className="w-full h-[360px] md:h-[460px] object-cover border-2 border-[#0F0F0F]"
          />
          <div className="hidden md:block absolute -bottom-6 -right-6 bg-[#0F0F0F] text-white p-6 max-w-[220px] border-2 border-[#0F0F0F]">
            <p className="font-heading font-black text-3xl text-[#FFC000]">Since 2024</p>
            <p className="text-sm text-white/80 mt-1">Serving our community with dignity and hope.</p>
          </div>
        </div>

        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#4A4A4A]">Who We Are</span>
          <h2 className="mt-3 font-heading font-black tracking-tight text-3xl md:text-4xl text-[#0F0F0F] leading-tight">
            More than housing —<br /> a foundation for a new beginning.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#4A4A4A] leading-relaxed">
            Make Room for Believers Independent Living Program exists to help people facing transition find not just a roof, but a real community. We combine stable housing with practical life-skills coaching, employment support, and genuine relationships.
          </p>
          <p className="mt-4 text-base md:text-lg text-[#4A4A4A] leading-relaxed">
            Whether you are aging out of care, rebuilding after hardship, or simply ready for your next step, our doors — and our hearts — are open.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {VALUES.map((v) => (
              <div key={v.label} data-testid={`value-${v.label.toLowerCase().replace(/\s/g, "-")}`} className="bg-[#F9F9F8] border-2 border-[#0F0F0F]/10 p-5 hover:border-[#0F0F0F] transition-colors">
                <v.icon size={22} strokeWidth={2} className="text-[#0F0F0F]" />
                <h3 className="mt-3 font-heading font-bold text-sm text-[#0F0F0F]">{v.label}</h3>
                <p className="text-xs text-[#4A4A4A] mt-1 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>

          <ul className="mt-8 space-y-2">
            {["No application fees, ever", "Faith-friendly, welcoming to all", "Personalized support plans"].map((t) => (
              <li key={t} className="flex items-center gap-3 text-[#0F0F0F] font-medium">
                <span className="w-5 h-5 bg-[#FFC000] border-2 border-[#0F0F0F] flex items-center justify-center flex-shrink-0"><Check size={12} strokeWidth={3} /></span>
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
